import { useCallback, useMemo } from 'react';
import { useReactiveVar } from '@apollo/client';
import { rowStatesVar, updateRowState as updateRowStateVar } from '../apollo/reactive-variables/row-states';

const useRowDateToPayState = (rowId) => {
  const rowStates = useReactiveVar(rowStatesVar);

  const isSingleRowModified = useMemo(() => {
    const currentValue = rowStates[rowId];
    return currentValue === undefined ? false : currentValue;
  }, [rowStates[rowId]]);

  const setSingleRowModified = useCallback((value) => {
    updateRowStateVar(rowId, value);
  }, [rowId, rowStates[rowId]]);

  const toggleModified = useCallback(() => {
    updateRowStateVar(rowId, !isSingleRowModified);
  }, [rowId, isSingleRowModified]);

  return {
    isSingleRowModified,
    setSingleRowModified,
    toggleModified,
  };
};

export default useRowDateToPayState;
